<template>
	<div @click="wrocclick">
		<div class="border" @click="wrocclick">
			<div id="barcode" class="barcodeStyle">
				 <ejs-barcodegenerator
					  id="barcode"
					  ref="barcodeControl"
					  :width="width"
					  :height="height"
					  :type="type"
					  :value="getNumerPw()"
					  :mode="mode"
					></ejs-barcodegenerator>
			 </div>
			<div class="borderin3b txtleft">Towar: <strong>{{ getTowar() }}</strong></div>
			<div class="borderin4 txtleft">Waga: <strong>{{ getWaga() }}</strong></div>
			<div class="borderin1b txtleft">Dostawca: <strong>{{ getDostawca() }}</strong></div>
			<div class="borderin4b txtleft">PZ: <strong>{{ getNumerPz() }}</strong></div>
			<div class="borderin2 txtleft">Data mrożenia: <strong>{{ getDataMrozenia() }}</strong></div>
			<div class="borderin2 txtleft">Skrzynia dnia: <strong>{{ getSkrzynia() }}</strong></div>

		</div>
		<div class="divwroc" @click="wrocclick">
			<!-- <br/>
			<button class="wlabel"> WRÓĆ </button> -->
		</div>
	</div>

</template>



<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from '@syncfusion/ej2-vue-barcode-generator';
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(BarcodeGeneratorPlugin);

export default {
	name: 'etykieta',
	props: {
	},
	data: ()=>({
	  dselected: [],
	  data: [],
          width: "200px",
          height: "104px",
          mode: "SVG",
          type: "Code128",
	  jwt: "",
	  backto: "/main",
	  noswaga: 0,
	  	iloscnosnika:0,
		ilopak: 0,
		sumaopak: 0,
		nadwyzka: 0,
		id_nosnika: 0,
		id_opakowania: 0
	}),
	methods: {
		getTowar() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].towar;
			} else {
				return "";
			}
		},
		getDostawca() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].dostawca;
			} else {
				return "";
			}
		},
		getDataMrozenia() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].dataMrozenia.substring(0, 10);
			} else {
				return "";
			}
		},
		getNumerPw() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].numerPW;
			} else {
				return "";
			}
		},
		getNumerPz() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].numerPZ;
			} else {
				return "";
			}
		},
		getWaga() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].wagaTowaru;
			} else {
				return "";
			}
		},
		getSkrzynia() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].numerSkrzyni;
			} else {
				return "";
			}
		},
		getData(id, skrzynia_id) {
	  	var url = "/agent/GALEK.Magazyn/GetDokumentPWEtykieta";
                return axios
                        .get(CONFIG.API_URL + url + "/" + id + "/" + skrzynia_id, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        	},
		wrocclick() {
			if(this.iloscnosnika !==0 && this.id_nosnika !== 0)
			this.$router.push({ path: this.backto, query: { iloscnosnika: this.iloscnosnika, noswaga: this.noswaga, ilopak: this.ilopak, sumaopak: this.sumaopak, nadwyzka: this.nadwyzka, id_nosnika: this.id_nosnika, id_opakowania: this.id_opakowania} });
			else
                	this.$router.push({ path: this.backto });
        	},

	},
	mounted() {
		var params = this.$route.query;
		var id = "";
		var zlecenie_id = -1;
		var skrzynia_id = -1;
		var prev = "/main";
		var prev2 = "/main";
		if (params["item"]) {
			id = params["item"];
		}
		if (params["id_zlecenia"]) {
			zlecenie_id = params["id_zlecenia"];
		}
		if (params["skrzynia"]) {
			skrzynia_id = params["skrzynia"];
		}
		if (params["prev"]) {
			prev = params["prev"];
		}
		if (params["prev2"]) {
			prev2 = params["prev2"];
			if (prev2.length > 0) {
				prev2 = prev2.substring(1);
			}
		}
		if(params["iloscnosnika"]){
				this.iloscnosnika = params["iloscnosnika"]
			}
			if(params["noswaga"]){
				this.noswaga = params["noswaga"]
			}
			if (params["ilopak"]){
				this.ilopak = params["ilopak"]
			}
			if (params["sumaopak"]){
				this.sumaopak = params["sumaopak"]
			}
			if (params["nadwyzka"]){
				this.nadwyzka = params["nadwyzka"]
			}
			if (params["id_nosnika"]){
				this.id_nosnika = params["id_nosnika"]
			}
			if (params["id_opakowania"]){
				this.id_opakowania = params["id_opakowania"]
			}
		this.backto = prev + "?id_zlecenia=" + zlecenie_id + "&prev=" + prev2;
        	var that = this;
		var selected = [];
        	Storage.loadJWT("jwt").then(resp => {
                	//alert(resp.access_token);
                	that.jwt = resp.access_token;
        		this.getData(id,skrzynia_id).then(data => {
                		that.data = data;
				if (id !== "" && that.data.length > 0) {
					selected.push(that.data[0]);
					that.dselected.push(selected.pop());
					//alert(JSON.stringify(that.dselected));
					setTimeout(myprint, 1000);
				}
        		});
        	});
	}
}

function myprint() {
	window.print();
}
</script>

<style>
.wroc {
        width: 200px;
        height: 168px;
        text-align: left;
        float: left;
}
.barcodeStyle {
        height: 100px;
        width: 200px;
    }
.border {
	font-size: 0.85em;
        border: 1px solid green;
        width: 200px;
        height: 278px;
}
.borderin1 {
        width: 200px;
        height: 80px;
}
.borderin1b {
        width: 190px;
        height: 28px;
}
.borderin2 {
        width: 200px;
        height: 15px;
}
.borderin3 {
        width: 200px;
        height: 40px;
}
.borderin3b {

        width: 190px;
        height: 43px;
}
.borderin4 {
        width: 200px;
        height: 13px;
}
.borderin4b {
	width: 190px;
	height: 60px;
}
.borderin5 {
        border: 1px solid black;
        width: 200px;
        height: 50px;
        float: right;
        padding: 2% 2% 2% 2%;
        margin: 2% 2% 5% 2%;
        position: relative;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
.print { 
	margin-left: 0px;
}
.txtleft {
	text-align: left;
	margin-left: 6px;
}
.divwroc{
	width: 100%;
	height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/EtykietaDrukujPWE.vue